import { fetchPrivateApi } from '@/lib/api/apiServiceBase.ts';
import {
  CreateTourConsentDto,
  TourConsentDto,
  UpdateTourConsentDto,
} from '@/features/dashboard/tourConsents/types/TourConsentDto.ts';

const tourConsentsApi = {
  create: async (dto: CreateTourConsentDto): Promise<TourConsentDto> => {
    return await fetchPrivateApi<TourConsentDto>(
      'POST',
      'tour-consents/single',
      dto,
    );
  },
  edit: async (
    id: string,
    dto: UpdateTourConsentDto,
  ): Promise<TourConsentDto> => {
    return await fetchPrivateApi<TourConsentDto>(
      'PUT',
      `tour-consents/single/${id}`,
      dto,
    );
  },
  getAll: async (tourId: string): Promise<TourConsentDto[]> => {
    return await fetchPrivateApi<TourConsentDto[]>(
      'GET',
      `tour-consents/${tourId}`,
    );
  },
  remove: async (id: string): Promise<void> => {
    return await fetchPrivateApi<void>('DELETE', `tour-consents/single/${id}`);
  },
};

export default tourConsentsApi;
